export default __webpack_public_path__ + "static/media/btn-delete-reg.1f69271a.svg";